import { useFormContext } from "react-hook-form";
import { IAnswer, QUESTION_TYPES } from "src/pages/DashboardPage/acadia/components/Tests/types";

export const QuestionTypeSelect = () => {
  const { register, getValues, setValue } = useFormContext();

  const handleChangeQuestionType = () => {
    const answersTest = getValues("AnswersTest");
    const editCorrectAnswer = answersTest?.map((answer: IAnswer) => ({
      ...answer,
      IsCorrect: false
    }));
    setValue("AnswersTest", editCorrectAnswer, { shouldValidate: true, shouldDirty: true });
  };

  return (
    <div>
      <div>
        <div className="flex justify-between">
          <p className="mb-[10px] text-base text-black font-medium">Тип вопроса</p>
          <span className="text-red text-base font-bold">*</span>
        </div>
        <select
          defaultValue={QUESTION_TYPES.MULTIPLE}
          {...register("TypeQuestion", { required: true, onChange: handleChangeQuestionType })}
          className="w-full rounded-md shadow-custom mb-5 border-[#DFE4EA] focus:border-[#DFE4EA]"
        >
          <option value={QUESTION_TYPES.MULTIPLE}>Множественный выбор</option>
          <option value={QUESTION_TYPES.SINGLE}>Единичный выбор</option>
        </select>
      </div>
    </div>
  );
};
